import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { ConsolidatedTransactionDetails } from '../../../../transaction/src/domain/Transaction/entities/ConsolidatedTransaction';
import { TransactionServiceImpl } from '../../../../transaction/src/domain/Transaction/usecases';
import { Mandate } from '../../domain/Authorization/entities';
import { AuthorizationServiceImpl } from '../../domain/Authorization/usecases';
import { CheckMandateResponseBody } from '../../domain/Authorization/entities/CheckMandateResponseDTO';
import { IAuthorizationService } from '../../domain/Authorization/entities/IAuthorizationService';

export interface AuthorizationProviderState {
  checkAuthorizationData?: Nullable<CheckMandateResponseBody>;
  selectedAuthorization: Nullable<Mandate & { timestamp: string }>;
  transactionDetails?: Nullable<ConsolidatedTransactionDetails>;
  bulkAuthorizations?: Nullable<Mandate[]>;
  onSelectAuthorization: (transactionNo: string) => void;
  loadingState: {
    isLoadingTransactionDetails: boolean;
    isLoadingCheckAuthorization: boolean;
  };
  errorState: {
    transactionDetailsError?: AxiosError<APIGatewayResponse<ConsolidatedTransactionDetails>>;
    checkAuthorizationError?: AxiosError<APIGatewayResponse<CheckMandateResponseBody>>;
  };
  authorizationToExecute: Nullable<{
    appTransactionId: string;
    accepted: boolean;
    cancellationReason: string;
    orderCode: string;
    dealerRateRequest: boolean;
    timestamp: string;
  }>;
  authorizationToCheck: Nullable<{
    accountNumber: string;
    uniqueId: number;
    amount: number;
    timestamp: string;
  }>;
  requestSpecialRate: boolean;
  isAuthorizationTransactionDetailsDrawerOpen: boolean;
  isAuthFlowDrawerOpen: boolean;
  toggleAuthorizationTransactionDetailsDrawer: () => void;
  onToggleAuthFlowDrawer: () => void;
  onTransactionDetailsMutation: () => void;
  onCheckAuthorizationMutation: () => void;
  initiateMandateService: () => IAuthorizationService['InitiateMandate'];
  initiateBulkMandatesService: () => IAuthorizationService['InitiateBulkMandates'];
  executeMandateService: () => IAuthorizationService['ExecuteMandate'];
  executeBulkMandatesService: () => IAuthorizationService['ExecuteBulkMandates'];
  onBulkAuthorizationSelect: (transactionId: string) => void;
  onMassiveAuthorizationSelection: (selectAllAuthorizations: boolean) => void;
  onSetRequestNewRate: (value: boolean) => void;
  authAction: Nullable<string>;
  onSetAuthAction: (actionName: Nullable<string>) => void;
  shouldShowRequestNewRateBtn: boolean;
}

export interface AuthorizationServicesState {
  authorizationService: Nullable<AuthorizationServiceImpl>;
  transactionService: Nullable<TransactionServiceImpl>;
}

export enum AuthorizationServicesActionTypes {
  SetServices = '@@/Authorization/setServices',
}

export enum AuthorizationActionTypes {
  SetSelectedAuthorization = '@@/Authorization/setSelectedAuthorization',
  SetAuthorizationTransactionDetailsDrawer = '@@/Authorization/SetAuthorizationTransactionDetailsDrawer',
  SetAuthFlowDrawerOpen = '@@/Authorization/SetAuthFlowDrawerOpen',
  SetLastTransactionDetailsGlobalOrderIdRetrieved = '@@/Authorization/SetLastTransactionDetailsGlobalOrderIdRetrieved',
  SetBulkAuthorizations = '@@/Authorization/SetBulkAuthorizations',
  SetRequestSpecialRate = '@@/Authorization/SetRequestSpecialRate',
  SetAuthAction = '@@/Authorization/SetAuthAction',
}
